// extracted by mini-css-extract-plugin
export default {"host":"style_host__z1hN1","divider":"style_divider__uwqk6","info":"style_info__ocWcU","overline":"style_overline__EjTy4","name":"style_name__tUYs0"};